export default __webpack_public_path__ + "static/media/tsa-small-banner.c55547b8.jpg";